export const path = "M 12 1 L 8 5 L 11 5 L 11 23 L 13 23 L 13 5 L 16 5 L 12 1 z";